/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GrantCreateGranteeLevel = typeof GrantCreateGranteeLevel[keyof typeof GrantCreateGranteeLevel] | null;


export const GrantCreateGranteeLevel = {
  job: 'job',
  job_candidate: 'job_candidate',
  project: 'project',
} as const;
